import React from "react";
import { useTranslation } from "react-i18next";

import MainLayouts from "../layouts/MainLayouts";
import AboutSection from "../components/AboutSection";
import MissionSection from "../components/MissionSection/MissionSection";
import IntroSection from "../components/IntroSection";
import IntroAbout from "../assets/Intro-about.png";
import FocusSection from "../components/FocusSection";
import Contact from "../components/Contact";
import LeadershipSection from "../components/LeadershipSection";
import HistorySection from "../components/HistorySection";
import PartnersSection from "../components/PartnersSection";

export default function AboutUs() {
    const { t } = useTranslation();

    return (
        <MainLayouts pageTitle={t("about.pageTitle")}>
            <h1 className="font-geologica text-[36px] font-medium leading-[100%] uppercase text-primary-400 mb-2 mt-3">
                    {t("about.pageTitle")}
                </h1>
            <div className="flex flex-col gap-[80px] md:gap-[90px] lg:gap-[100px]">
                <IntroSection titleKey="about.subtitle" imgSrc={IntroAbout} /*buttonTextKey="buttons.moreDetails"*/ />
                <MissionSection />
                <FocusSection />
                <LeadershipSection />
                <HistorySection />
                <PartnersSection />
                <Contact />
            </div>
        </MainLayouts>
    );
}
